import { memberLogin, memberInfo } from "@/api/member.js";
import bridgeMsg from "@/js_sdk/bridgeMsg.js";
import paramsCryptoUtil from "@/js_sdk/paramsCryptoUtil.js";
import { hideSkeleton } from "../skeleton";
import { localeMap } from "@/constants/index";

export const doLogin = () => {
  return new Promise((resolve, reject) => {
    if (
      window.location.hostname?.includes("localhost") ||
      window.location.hostname?.includes("192.168.0.134")
    ) {
      hideSkeleton();
      memberLogin({
        productKey: "1cad3c83-d87",
        token: "12bgd5qhoa5vjcyijilj41jcarpoh0elgtw",
      }).then((res) => {
        const token = res.data.tokenHead + res.data.token;
        uni.setLocale("zh-TW");
        getApp().$i18n.locale = "zh-TW";
        uni.setStorageSync("token", token);
        // uni.setStorageSync("productKey", productKey);
        // uni.setStorageSync("appToken", appToken);
        memberInfo().then((response) => {
          resolve(response.data);
        });
      });
      return;
    }
    bridgeMsg.message("getPageParams", ({data}) => {
      const pageParams = data.data || data;
      const {
        productKey,
        token: appToken,
        lang,
        ...rest
      } = pageParams;
      const localeLang = localeMap[lang] || lang?.split("_")?.[0] || "en";
      uni.setStorageSync("app-lang", lang);
      uni.setLocale(localeLang);
      getApp().$i18n.locale = localeLang;
      hideSkeleton();
      memberLogin({
        productKey,
        token: appToken,
      })
        .then((res) => {
          const token = res.data.tokenHead + res.data.token;
          uni.setStorageSync("token", token);
          uni.setStorageSync("productKey", productKey);
          uni.setStorageSync("appToken", appToken);
          memberInfo().then((response) => {
            // this.login(response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          uni.navigateTo({ url: "/pages/public/error" });
        });
    });
  });
};
